import { Card } from 'antd';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { ReportsMain } from '../../components/Reports';

export const Reports = () => {
  return (
    <Card bordered={true} title={<TitleBreadcrumbs />} className="gx-card">
      <ReportsMain />
    </Card>
  );
};
